import {
  Box,
  IconButton,
  Link,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { FC } from "react";
import { classes, footerHeight } from "./footer.style";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { useIsMobileView } from "src/modules/shared/hooks/use-is-mobile-view";

export const Footer: FC = () => {
  const isMobile = useIsMobileView();
  const small = useMediaQuery("(max-height:600px)");

  return (
    <Box sx={classes.root} component="footer">
      <Toolbar
        sx={{
          ...classes.toolbar,
          height: small ? "56px" : { xs: "56px", sm: footerHeight },
        }}
      >
        <Typography sx={classes.info}>
          2021 &copy; ID TAG TECHNOLOGY GROUP AS. All rights reserved
        </Typography>

        {!isMobile && (
          <Box sx={classes.socials}>
            <Typography sx={classes.info}>Find us on:</Typography>

            <Link
              href="https://www.youtube.com/channel/UCQusvXSr4jRgx2Q_SLvUaug"
              target="_blank"
            >
              <IconButton color="inherit" edge="end">
                <YouTubeIcon />
              </IconButton>
            </Link>
          </Box>
        )}
      </Toolbar>
    </Box>
  );
};
